import React from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import SectionCard from '../ui/SectionCard';
import { EditableRow } from '../dashboard/Row';
import * as actions from '../../../../redux/actions';

// หมายเหตุ/Note — แยกออกมาจาก OpportunityInfoCard ให้อยู่คอลัมน์ขวาเหนือการ์ดสถานะโครงการ (ตามที่ user ขอ)
// บันทึกแบบเดียวกับ patchField ใน useOpportunityDashboard.js (optimistic onLocalUpdate แล้ว refetch, ล้มเหลว
// = refetch ย้อนค่าจริง) เขียนเองตรงนี้ไม่เรียก hook นั้นซ้ำ เพราะ hook ดึงพนักงาน/ลูกค้าทั้งหมดทุกครั้งที่ mount
// — key remark/note เป็นชื่อเดียวกันทั้ง camelCase (action) และ snake_case (DB) ไม่ต้อง map
export function NoteCard({
  opportunity, onChanged, onLocalUpdate, showSnack,
}) {
  const dispatch = useDispatch();

  const patchField = async (payload) => {
    onLocalUpdate?.(payload);
    try {
      await dispatch(actions.updateOpportunity({ id: opportunity.id, ...payload }));
      onChanged();
    } catch (err) {
      showSnack(err.message || 'บันทึกไม่สำเร็จ', 'error');
      onChanged();
    }
  };

  return (
    <SectionCard icon={<EditNoteOutlinedIcon />} title="บันทึก" accentColor="primary.main">
      <Box>
        <EditableRow
          label="หมายเหตุ"
          type="textarea"
          value={opportunity.remark}
          displayValue={opportunity.remark}
          onSave={(v) => patchField({ remark: v })}
        />

        <EditableRow
          label="Note"
          type="textarea"
          value={opportunity.note}
          displayValue={opportunity.note}
          onSave={(v) => patchField({ note: v })}
          clearOnEdit
        />
      </Box>
    </SectionCard>
  );
}

export default NoteCard;
